import * as React from "react";
import { forwardRef } from "react";
const SvgSendRequest = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z", fill: "#F7F8FA" }));
const ForwardRef = forwardRef(SvgSendRequest);
export { ForwardRef as ReactComponent };
